var _module = require('../module');
var _ = require('lodash');
var simpleCypher = require('../../../libs/simple-cypher');
var $ = require('jquery');
var config = require('config');
var addressParser   = require ('parse-address');

require('angular-ui-router');
require('../third-party/angular-slick');
require('../third-party/angular-google-staticmaps');
require('../google-search-autocomplete');
require('../mobile-alerts-banner');
require('../window-height');
require('../../services/listing');
require('../../services/map-modal');
require('../../services/lr-touch');
require('../../services/user');
require('../../services/verify-modal');
require('../../services/login-or-register-modal');
require('../../services/search-results-utils');
require('../../services/listhub');
require('../../services/analytics');
require('../../services/activity-feed');
require('../../services/fullscreen-loading');
require('../../services/fullscreen-carousel');
require('../../services/firstam');
require('../../services/babou');
require('../../filters');
require('../lrphotowall');
require('../../services/analytics');
require('../related-listings');
require('../mortgage-calculator');
require('../favorite-btn');
require('../prequalify-button');
require('../share-btn');
require('../stickyheader');
require('../../services/inactive-listing-modal');
require('../../services/lighapi');
require('../../services/mls-accept-toc');
require('../../services/contact-listing-agent-modal');

_module.requires.push('ui.router', 'slickCarousel', 'wu.staticGmap');

_module.filter('unique', function() {
    return function (collection, field) {
        return _.uniqBy(collection, field);
    };
});

_module.component('viewlisting', {
    controllerAs: 'viewlisting',
    controller: [
        '$log',
        '$scope',
        '$location',
        '$q',
        '$state',
        '$stateParams',
        'Listing',
        '$user',
        '$mapModal',
        '$loginOrRegisterModal',
        '$verifyModal',
        'srUtils',
        '$listhub',
        '$analytics',
        '$activityFeed',
        '$fsloading',
        '$fscarousel',
        '$firstam',
        '$timeout',
        '$inactiveListingModal',
        '$lighapi',
        '$babou',
        '$mlsAcceptToC',
        '$http',
        '$contactListingAgentModal',
        '$thankyouModal',

        function viewlistingCtrl($log, $scope, $location, $q, $state, $stateParams, Listing, $user, $mapModal, $loginOrRegisterModal, $verifyModal, srUtils, $listhub, $analytics, $activityFeed, $fsloading, $fscarousel, $firstam, $timeout, $inactiveListingModal, $lighapi, $babou, $mlsAcceptToC, $http, $contactListingAgentModal, $thankyouModal) {
            $log.debug('view listing', this);
            $log.debug('$stateParams', $stateParams);

            var _this = this;
            var lighapiPromise;

            /**
             * Any affiliate code in this array will not show
             * the affiliates info under the team section. This
             * will normally be used for auditing accounts.
             *
             * @property {Array} affiliateCodeExceptions
             */
            this.affiliateCodeExceptions = [
                'home'
            ];
            this.why = [];
            this.whyNot = [];
            this.showMoreFeatures = true;
            this.showMoreDescription = false;
            this.listing = null;
            this.matchScore = '?';
            this.addressSplit = '';
            this.images = [];
            this.infographics = [];
            this.searchValue = '';
            this.affiliate;
            this.user = $user;
            this.descriptionLimit = 650;
            this.descriptionSize = 0;
            this.isFavorite = false;
            this.favoriteId = null;
            this.filterId = $stateParams.filter;
            this.showListingNotFound = false;
            this.mortgageCalculatorCurrentValues = undefined;
            this.fairHousingCompliance = undefined;
            this.stickyHeaderLinks = [
                {
                    label: 'About the Home',
                    id: 'about-the-home',
                    hide: false
                },
                {
                    label: 'Match Score',
                    id: 'match-score',
                    hide: false
                },
                {
                    label: 'Infographics',
                    id: 'infographics',
                    hide: true
                },
                {
                    label: 'Payment Calculator',
                    id: 'payment-calculator',
                    hide: false
                },
                {
                    label: 'Features',
                    id: 'features',
                    hide: false
                }
            ];

            var decoded = simpleCypher.decode($stateParams.listingId);
            if (decoded && decoded.source === 'listhub') {
                $listhub('submit', 'DETAIL_PAGE_VIEWED', { lkey: decoded.id });
            }

            // Get Listing
            var promises = [Listing.selectListing($stateParams.listingId)];

            if($stateParams.filter) promises.push($user.getSearchFilter($stateParams.filter));

            $fsloading.show();

            $q.all(promises)
                .then(function getListing(response) {
                    var listing = response[0];
                    var filter = response[1];

                    $mlsAcceptToC.checkZipCodes(listing.postal_code);

                    if(decoded && decoded.id && decoded.source) {
                        _this.decodedListingId = decoded.id;
                        _this.decodedListingSource = decoded.source;

                        if(decoded.source === 'listhub' && !listing.active) {                           
                            throw new Error('Inactive listing');
                        }

                        if(!listing.photos.length) {
                            if(decoded.source === 'firstam'){
                                $firstam.getPhotos(listing.id)
                                    .then(function onPhotoResponse(photos) {
                                        if(angular.isArray(photos) && photos.length) {
                                            var photoArr = photos.map(function (p) {
                                                return p.MediaURL;
                                            });
                                            photoArr = photoArr.filter(function (p) {
                                                return angular.isDefined(p) && p;
                                            });
                                            if(photoArr.length) {
                                                appendInfographicsToPhotos(photoArr);
                                            }
                                        }
                                    })
                                    .catch(function onPhotoError(err) {
                                        $log.error('Error fetching FA photos', err);
                                    });
                            }
                        }

                        var realtor = _.get(listing, 'realtor', {});
                        var result = $babou.getPreferredAgent(realtor,{
                            cache: true,
                            include_aliases: false,
                            include_followers: false,
                            include_listing_stats: true,
                            include_listings: false,
                            retries: 0,
                            timeout: 10000
                        });
                        _this.listing = listing;
                        result.then(function agentDetails(response) {
                            if (response.preferred_profile) {
                                realtor = response.preferred_profile;
                                listing.realtor = realtor;
                            }
                            if (realtor && realtor.first_name && realtor.company && (realtor.email || realtor.phone)) {
                                listing.realtor.$minimumInfoFound = true;
                            } else {
                                listing.realtor.$minimumInfoFound = false;
                            }
                        });
                    } else {
                        $log.error('Decode ID error', decoded);
                    }

                    $log.debug('listing', _this.listing);

                    _this.addressSplit = _this.listing.address.replace(/^([\w\s\d#.]*)(,)(\s)/i, '$1{{SPLITME}}').split('{{SPLITME}}');

                    if(filter) {
                        var whyAndWhyNot = filter.whyAndWhyNot(_this.listing);

                        $log.debug('filter', filter);
                        $log.debug('whyAndWhyNot', whyAndWhyNot);

                        if(whyAndWhyNot) {
                            _this.why = whyAndWhyNot.why;
                            _this.whyNot = whyAndWhyNot.whyNot;
                        }

                        _this.matchScore = filter.rankListing(_this.listing);

                        if(!_this.matchScore && _this.matchScore !== 0) _this.matchScore =  '?';
                    }

                    initSlickConfig();
                    checkIfListingIsActive();
                    getListingFairHousingCompliance();

                    _this.listing.days_on_market = srUtils.getDaysOnMarket(_this.listing);

                    try {
                        _this.descriptionSize = _this.listing.description.length || 0;
                    } catch (err) {
                        _this.descriptionSize = 0;
                    }

                    if($stateParams.openhouse) {
                        $timeout(function () {
                            var $container = $('html,body');
                            var $scrollTo = $('.open-house');

                            $container.animate({ scrollTop: ($scrollTo.offset().top - $container.offset().top + $container.scrollTop() - 100), scrollLeft: 0 }, 300);
                        }, 900);
                    }

                    $log.debug(_this.addressSplit);
                    $log.debug(_this.matchScore);
                })
                .catch(function getListingError(err) {
                    _this.showListingNotFound = true;
                })
                .finally(function () {
                    appendInfographicsToPhotos();
                    $fsloading.hide();
                });


            // Get Infographics
            Listing.getInfographics($stateParams.listingId)
                .then(function infographicsResponse(response) {
                    _this.infographics.push.apply(_this.infographics, _.values(response));
                    appendInfographicsToPhotos();
                    _.find(_this.stickyHeaderLinks, { label: 'Infographics' }).hide = false;
                })
                .catch(function infographicsError(err) {
                    $log.error('Get Infographics Error', err.data);
                });


            // Lifecycle Hooks
            this.$onDestroy = function onDestroy() {
                sendMortgageCalculatorInteractedMixpanelEvent();
                createMortgageCalculatorInteractedActivity();
            };


            // Internal Functions
            var initSlickConfig = function initSlickConfig() {
                _this.currentSlickIndex = 0;
                _this.slickConfig = {
                    method: {},
                    event: {
                        afterChange: function (event, slick, currentSlide, nextSlide) {
                            $timeout(function () {
                                _this.currentSlickIndex = currentSlide; // save current index each time
                            });
                        }
                    }
                };
            };

            var resetCurrentSlide = function (response) {
                $timeout(function () {
                    if(angular.isDefined(response) && !isNaN(response)) {
                        var i = parseInt(response, 10);
                        if(_.has(_this, 'slickConfig.method.slickGoTo')){
                            _this.currentSlickIndex = i;
                            _this.slickConfig.method.slickGoTo(i);
                        }
                    }
                });
            };

            // $watch Functions
            $scope.$watch(function () { return $user.affiliate; }, function onAffiliateChange(value) {
                if(value)
                    _this.affiliate = value;
            }, true);

            // Functions
            this.infographicsCustomDot = function infographicsCustomDot(slick, i) {
                return '<a class="btn btn-link"><img src="' + this.infographics[i] + '" class="img-responsive" /><div class="overlay"></div></a>';
            };

            this.onSlideClick = function onSlideClick($index, images) {
                if(_this.listing) {
                    $fscarousel(images, $index);
                }
            };

            this.showMap = function showMap() {
                $mapModal([_this.listing.lat, _this.listing.lon]);
            };

            this.onListingSearch = function onListingSearch() {
                $log.debug('onListingSearch', _this.listingSearch, _this.searchValue);

                if(_this.searchValue) {
                    $analytics.eventTrack('Listing Search Submit', {
                        Source: 'Detail Page',
                        'Search Term': _this.searchValue
                    });

                    $state.go('search', { q: _this.searchValue });
                }
            };

            this.onShowMeTheHomeClick = function onShowMeTheHomeClick() {
                var url = 'mailto:' + $user.affiliate.email + '?';
                var subject = 'subject=nest.me Inquiry for ' + _this.listing.address + ' - ' + $user.full_name;
                var body = 'body=Hi ' + $user.affiliate.name + ',';
                body += '%0D%0A';
                body += '%0D%0A';
                body += "I'm interested in a property I found on nest.me at " + _this.listing.address + '.';

                window.open(url + subject + '&' + body, '_self');

                if($user.account_type !== 'guest') {
                    $user.sendShowMeTheHomeNotifications(_this.listing, $user.affiliate, $user.affiliate.benoit_partner)
                        .then(function onSuccess(response) {
                            $log.debug('Show Me The Home Notifications Success!', response);

                            $activityFeed.add({
                                avatar: 'initials',
                                type: 'lead',
                                name: 'benoit_user_click_show_me_home_button',
                                userId: $user.affiliateId,
                                meta: {
                                    benoitPartnerId: $user.affiliate.benoitPartnerId,
                                    benoitUserId: $user.id,
                                    name: $user.full_name,
                                    first_name: $user.first_name,
                                    last_name: $user.last_name,
                                    phone: $user.phone,
                                    email: $user.email,
                                    address: _this.listing.address,
                                    listingId: _this.decodedListingId,
                                    listing_source: _this.listing.listing_source,
                                    filterId: _this.filterId
                                }
                            });
                        }).catch(function (err) {
                            $log.error('Show Me The Home Notifications Error!', err);
                        });
                }
            };

            this.onListingAgentContact = function onListingAgentContact() {
                $contactListingAgentModal(_this.listing)
                    .then(function () {
                        $log.debug('Agent contacted');
                        $listhub('submit', 'AGENT_EMAIL_SENT', { lkey: decoded.id });
                        $thankyouModal('Your email has been sent.');
                    })
                    .catch(function (err) {
                        $log.error('Error in contact agent modal');
                    });
            };

            this.addOpenHouseClicked = function addOpenHouseClicked(openhouse) {
                $log.debug(openhouse);

                if($user.account_type !== 'guest') {
                    $activityFeed.add({
                        avatar: 'initials',
                        type: 'lead',
                        name: 'benoit_user_click_add_open_house_to_calendar',
                        userId: $user.affiliateId,
                        meta: {
                            benoitPartnerId: $user.affiliate.benoitPartnerId,
                            benoitUserId: $user.id,
                            name: $user.full_name,
                            first_name: $user.first_name,
                            last_name: $user.last_name,
                            address: _this.listing.address,
                            listingId: _this.decodedListingId,
                            listing_source: _this.listing.listing_source,
                            filterId: _this.filterId,
                            full_date: openhouse.date + ' ' + openhouse.start_time,
                            date: openhouse.date,
                            time: openhouse.start_time
                        }
                    });
                }
            };

            this.onMortgageCalculatorInteraction = function saveMortgageCalculatorsCurrentValues($data) {
                _this.mortgageCalculatorCurrentValues = $data;
            };

            this.isLegacyTitleUser = function isLegacyTitleUser(user) {
                return user.type === 'lo' && user.vendor && (user.vendor.company_type === 'Title' || user.vendor.company_type === 'Escrow');
            };

            function sendMortgageCalculatorInteractedMixpanelEvent() {
                if(!_this.mortgageCalculatorCurrentValues) return;

                var eventData = {
                    'Match Score': _this.matchScore,
                    Address: _this.listing.address,
                    'Sq Ft': _this.listing.home_size,
                    Bed: _this.listing.beds,
                    Bath: _this.listing.baths,
                    Status: _this.listing.listing_status,
                    'Filter ID': _this.filterId,
                    Source: 'Detailed Page',
                    Price: _this.listing.price,
                    'Monthly Payment': Math.round(_this.mortgageCalculatorCurrentValues.monthly_payment),
                    'Down Payment': _this.mortgageCalculatorCurrentValues.down_payment,
                    'Down Payment Percent': _this.mortgageCalculatorCurrentValues.down_payment_percent * 100,
                    'Loan Type': _this.mortgageCalculatorCurrentValues.loan_type,
                    'Interest Rate': _this.mortgageCalculatorCurrentValues.interest_rate,
                    'Loan Amount': _this.mortgageCalculatorCurrentValues.principal
                };
                if(_this.mortgageCalculatorCurrentValues.property_taxes) {
                    eventData['Property Taxes'] = Math.round(_this.mortgageCalculatorCurrentValues.property_taxes);
                    eventData['Property Taxes Period'] = 'year';
                }
                if(_this.mortgageCalculatorCurrentValues.hoa_dues) {
                    eventData['HOA Dues'] = Math.round(_this.mortgageCalculatorCurrentValues.hoa_dues);
                    eventData['HOA Dues Period'] = _this.mortgageCalculatorCurrentValues.hoa_dues_period || 'month';
                }
                if(_this.mortgageCalculatorCurrentValues.hoi) {
                    eventData['Homeowners Insurance'] = Math.round(_this.mortgageCalculatorCurrentValues.hoi);
                    eventData['Homeowners Insurance Period'] = 'month';
                }
                if(_this.mortgageCalculatorCurrentValues.mortgage_insurance) {
                    eventData['Mortgage Insurance'] = Math.round(_this.mortgageCalculatorCurrentValues.mortgage_insurance);
                    eventData['Mortgage Insurance Period'] = 'month';
                }

                $analytics.eventTrack('Loan Calculator Interaction', eventData);
            }

            function createMortgageCalculatorInteractedActivity() {
                if(!_this.mortgageCalculatorCurrentValues || $user.account_type === 'guest') return;

                $activityFeed.add({
                    avatar: 'initials',
                    type: 'lead',
                    name: 'benoit_loan_calculator_interaction',
                    userId: $user.affiliateId,
                    meta: {
                        benoitPartnerId: $user.affiliate.benoitPartnerId,
                        benoitUserId: $user.id,
                        name: $user.full_name,
                        first_name: $user.first_name,
                        last_name: $user.last_name,
                        phone: $user.phone,
                        email: $user.email,
                        address: _this.listing.address,
                        listingId: _this.decodedListingId,
                        listing_source: _this.listing.listing_source,
                        filterId: _this.filterId,
                        calculator_values: _this.mortgageCalculatorCurrentValues
                    }
                });
            }

            function appendInfographicsToPhotos (photos) {
                var newListingPhotos = (angular.isArray(photos) && photos.length)
                    ? photos
                    : (_.has(_this, 'listing.photos'))
                        ? _this.listing.photos
                        : [];

                if(!_.has(_this, 'listing.photos') ||
                    (_.get(_this, 'listing.photos', null) &&
                    !_this.listing.photos.length
                    )) {
                    newListingPhotos.push('/images/hero_placeholder_full.png');
                }

                if(angular.isArray(_this.infographics) && _this.infographics.length) {
                    newListingPhotos = newListingPhotos.filter(function (url) {
                        return _this.infographics.indexOf(url) < 0;
                    });
                    newListingPhotos.push.apply(newListingPhotos, _this.infographics);
                }

                if(_this.listing) {
                    _this.listing.photos = newListingPhotos;
                }
            }

            function checkIfListingIsActive() {
                /**
                 * We are only going to check on the status of a listing
                 * if the listing is from dls.
                 */
                if(_this.listing.listing_source !== 'dls') return;

                lighapiPromise = $lighapi.search({ address: _this.listing.address, lid: $stateParams.listingId, listingstatus: _this.listing.listing_status });

                lighapiPromise
                    .then(function (response) {
                        $log.debug('checkIfListingIsActive Response', _this.listing.listing_status, response);

                        var foundDisplayableStatus = ~['Pending', 'In Escrow'].indexOf(response.ListingStatus) && response.ListingStatus !== _this.listing.listing_status;

                        if(response && ((!response.Active && response.ListingStatus !== 'Active') || foundDisplayableStatus)) {
                            $analytics.eventTrack('DLS Status Check Displayed', {
                                Address: _this.listing.address,
                                'Listing ID': _this.listing.id,
                                Source: 'nest.me',
                                Status: response.ListingStatus
                            });

                            $inactiveListingModal(response.ListingStatus)
                                .result
                                .then(function () {
                                    if(!foundDisplayableStatus) {
                                        var currentObject = $user.currentSearch ? $user.currentSearch : $user.currentFilter;

                                        if(currentObject && currentObject._pageData) {
                                            currentObject._pageData.data = _.reject(currentObject._pageData.data, { id: $stateParams.listingId });
                                        }

                                        $state.go('search', { reloadDataInBackground: !!$user.currentSearch, bypassCache: !!$user.currentSearch });
                                    } else {
                                        _this.listing.listing_status = response.ListingStatus;
                                    }
                                });
                        }
                    });
            }

            function getListingFairHousingCompliance() {
                $http.get('/v1/config/fair-housing')
                    .then(function(response) {
                        const complianceObj = response.data.data;
                        const listingState = addressParser.parseLocation(_this.listing.address).state.toLowerCase();
                        const listingCompliance = complianceObj[listingState]?.compliance_url || null;
                        _this.fairHousingCompliance = listingCompliance;
                    });
            }

            // Listeners
            this.$onDestroy = function () {
                Listing.deselectListing();
                lighapiPromise.abort();
            };
        }
    ],
    template: require('./index.html')
});
